
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';

interface VoltageRegulatorNoDataRowProps {
  isEmpty: boolean;
}

const VoltageRegulatorNoDataRow: React.FC<VoltageRegulatorNoDataRowProps> = ({ isEmpty }) => {
  return (
    <TableRow>
      <TableCell colSpan={7} className="text-center h-24 text-muted-foreground">
        {isEmpty ? 'No voltage regulator data found' : 'No regulators match current filters'}
      </TableCell>
    </TableRow>
  );
};

export default VoltageRegulatorNoDataRow;
